<i18n>
{
  "en": {
    "all": "All",
    "same": "Same Level",
    "bellow": "Level below",
    "manager":  "Manager",
    "employee": "Employee",
    "active":  "Active",
    "disabled": "Deactivated",
    "pointOfSale": "Filter by restaurant",
    "userRole": "Filter by use role",
    "userRoleLevel": "Filter by hierarchy level",
    "userActive": "Filter by user status",
    "userSearch": "Search by username"
  },
  "es": {
    "all": "Todos",
    "same": "Mismo nivel",
    "bellow": "Nivel por debajo",
    "manager":  "Manager",
    "employee": "Empleado",
    "active":  "Activo",
    "disabled": "Desactivado",
    "pointOfSale": "Filtrar por restaurante",
    "userRole": "Filtrar por rol de usuario",
    "userRoleLevel": "Filtrar por nivel de jerarquia",
    "userActive": "Filtrar por si el estado de usuario",
    "userSearch":  "Buscar por nombre de usuario"
  }
}
</i18n>
<template>
  <v-row>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4" md="3">
      <v-text-field class="pt-0" height="42" :placeholder="$t('userSearch')" :disabled="disabled" @input="onFinishTyping">
      </v-text-field>
    </v-col>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4" md="3">
      <v-select v-model="selectedPos" :items="pointOfSaleList" :label="this.$t('pointOfSale')"
                :disabled="disabled" multiple dense hide-details @change="onSelectPos"
                item-value="guid" item-text="name" chips height="42"
      />
    </v-col>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4" md="2">
      <v-select v-model="selectedRol" :items="selectorUserRoles" :label="this.$t('userRole')"
                :disabled="disabled" dense hide-details @change="onSelectUserRol" height="42"/>
    </v-col>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="6" md="2">
      <v-select v-model="selectedSameRoleLevel" :items="selectorBooleanTags" :label="this.$t('userRoleLevel')"
                :disabled="disabled" dense hide-details @change="onSelectUserRolLevel" height="42"/>
    </v-col>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="6" md="2">
      <v-select v-model="selectedUserActive" :items="selectorActiveUser" :label="this.$t('userActive')"
                :disabled="disabled" dense hide-details @change="onSelectUserActive" height="42"/>
    </v-col>
  </v-row>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MapGetters } from '@core/helpers/decorators';

@Component
@MapGetters(['pointOfSaleList'])
export default class UserListFilter extends Vue {
  @Prop({ type: Boolean, default: false }) disabled;

  selectedPos = [];

  selectedRol = 'all';

  selectedSameRoleLevel = 'no'

  selectedUserActive = 'all'

  get selectorBooleanTags() {
    return [
      { text: this.$t('all'), value: 'all' },
      { text: this.$t('same'), value: 'same' },
      { text: this.$t('bellow'), value: 'bellow' }
    ];
  }

  get selectorActiveUser() {
    return [
      { text: this.$t('all'), value: 'all' },
      { text: this.$t('active'), value: 'active' },
      { text: this.$t('disabled'), value: 'disabled' }
    ];
  }

  get selectorUserRoles() {
    return [
      { text: this.$t('all'), value: 0 },
      { text: this.$t('manager'), value: 1 },
      { text: this.$t('employee'), value: 2 },
    ];
  }

  onSelectPos(emitted) {
    this.$emit('pointOfSale', emitted);
  }

  onSelectUserRol(emitted) {
    this.$emit('userRole', emitted);
  }

  onSelectUserRolLevel(emitted) {
    this.$emit('userRoleLevel', emitted);
  }

  onSelectUserActive(emitted) {
    this.$emit('userActive', emitted);
  }

  onFinishTyping(emitted) {
    this.$emit('userSearch', emitted);
  }
}
</script>
